import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/recipes";

export default class Recipes extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Our Recipes | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
